import React from 'react'

import { isEmpty, isEqual, noop, some } from 'lodash'
import PropTypes from 'prop-types'

import api from 'common/api'
import Conversation from 'components/Conversation'
import ConversationInput from 'components/ConversationInput'
import withContext from 'components/RealtimeMessagingProvider/withContext'

import './index.scss'

export class SendChat extends React.Component {
  static propTypes = {
    userId: PropTypes.string.isRequired,
    recipient: PropTypes.shape({
      userId: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      school: PropTypes.string,
    }).isRequired,
    onMessageSent: PropTypes.func,
    disabled: PropTypes.bool,
    realtimeConnect: PropTypes.func.isRequired,
  }
  static defaultProps = {
    onMessageSent: noop,
    realtimeConnect: noop,
  }
  state = {
    hasConversation: false,
    discussion: {},
  }
  unregisterRealTimeListener = noop
  loadConversation(discussion) {
    api.get(`/api/discussions/${discussion.Id}/messages`).then((conversation) => {
      this.setState({
        hasConversation: true,
        conversation,
        discussion,
      })
    })
  }
  findDiscussion(recipient) {
    return api.get(`/api/discussions/participant/${recipient.userId}`).catch(() => ({}))
  }
  loadRecipientContext(props) {
    if (props.recipient.userId) {
      this.findDiscussion(props.recipient).then((discussion) => {
        if (isEmpty(discussion)) {
          this.setState({
            hasConversation: false,
          })
        } else {
          api.post(`/api/discussions/${discussion.Id}/read`)
          this.loadConversation(discussion)
        }
      })
    }
  }
  processRealTimeMessage(newMessage) {
    if (
      this.state.discussion.Id === newMessage.DiscussionId &&
      !some(this.state.conversation, { Id: newMessage.Message.Id })
    ) {
      this.setState({
        conversation: [...this.state.conversation, newMessage.Message],
      })
    }
  }
  componentDidMount() {
    this.unregisterRealTimeListener = this.props.realtimeConnect(`${this.props.userId}-MessageCentre`, (newMessage) =>
      this.processRealTimeMessage(newMessage),
    )
    this.loadRecipientContext(this.props)
  }
  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.recipient, this.props.recipient)) {
      this.loadRecipientContext(this.props)
    }
  }
  componentWillUnmount() {
    this.unregisterRealTimeListener()
  }
  newMessageThread() {
    this.props.onMessageSent()
    this.loadRecipientContext(this.props)
  }
  conversationUpdated() {
    this.props.onMessageSent()
    this.loadConversation(this.state.discussion)
  }
  render() {
    return (
      <div className="send-chat-comp">
        {this.state.hasConversation && (
          <div className="conversation-wrapper">
            <Conversation
              conversation={this.state.conversation}
              onMessageSent={() => this.conversationUpdated()}
              participants={this.state.discussion.Participants}
              discussionOwnerId={this.props.userId}
            />
          </div>
        )}
        {!this.state.hasConversation && (
          <div>
            <ConversationInput
              onMessageSentSuccess={() => this.newMessageThread()}
              participantIds={[this.props.userId, this.props.recipient.userId]}
              allowEnterToSendToggle={false}
              disabled={this.props.disabled}
            />
          </div>
        )}
      </div>
    )
  }
}
export default withContext({
  connect: 'realtimeConnect',
})(SendChat)
